import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PageChangeEvent } from '@progress/kendo-angular-grid';
import { IBase, IBaseSearchRequest, IGridResult, IGridState, PageSize } from 'src/app/core/models/base';
import { IOrder, OrderStates } from 'src/app/orders/models/order';

@Component({
    selector: 'app-order-grid',
    templateUrl: './order-grid.component.html',
    styleUrls: ['./order-grid.component.scss'],
    standalone: false
})
export class OrderGridComponent implements OnInit {

  constructor() { }

  @Input() orders: IGridResult<IOrder[]>;
  @Input() isAdminView: boolean = false;

  @Output() onReload = new EventEmitter<IBaseSearchRequest>();
  @Output() onChangeOrderState = new EventEmitter<IOrder>();

  get OrderStates(){
    return OrderStates
  }

  ngOnInit(): void {
  }

  request: IBaseSearchRequest = {
    pageNumber: 0,
    pageSize: 25
  }

  gridState: IGridState = {
    pageSize: 25,
    skip: 0,
  }

  get pageSizes() {
    return PageSize;
  }

  // Paging Start

  onPageSizeChange(pageSize: number) {
    this.onPageChange({ skip: this.gridState.skip, take: pageSize });
  }

  onGridReload() {
    this.onReload.emit(this.request);
  }

  onPageChange({ skip, take }: PageChangeEvent) {
    const page = Math.round((skip + take) / take);

    this.gridState.skip = skip;
    this.gridState.pageSize = take;

    this.request.pageNumber = page;
    this.request.pageSize = take;

    this.onReload.emit(this.request);
  }

  
  // Paging End
  onChangeOrderStateClick(dataItem){
    this.onChangeOrderState.emit(dataItem);
  }
}
